module.exports = __webpack_public_path__ + "static/media/illuEuropraid2017_1_01_full.c78c6ebd.gif";